import { useContext } from "react";
import { ExplanationSidebarContext } from "../ExplanationSidebarContext";

export const useExplanationSidebar = () => {
  const context = useContext(ExplanationSidebarContext);
  if (!Object.keys(context).length)
    throw new Error(
      "useExplanationSidebar must be used within a ExplanationSidebarContext"
    );
  return context;
};
